import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import FormattedShortQuarterYear from 'I18n/components/FormattedShortQuarterYear';
import Raven from 'raven-js';
import { formatDate } from '../../utils/dateRangeUtils';
import { isTimePeriodCustom, getQuarterFromDate } from '../../utils/dateUtils';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const MONTHS_IN_QUARTER = 3;
export const FormattedPeriod = ({
  timePeriod,
  offset = 0
}) => {
  const periodDate = new Date();
  periodDate.setDate(2); // set to second of month to account for different length months (and portal tz vs user tz mismatch)
  if (isTimePeriodCustom(timePeriod)) {
    const formattedStart = formatDate(timePeriod.get('startDate'));
    const formattedEnd = formatDate(timePeriod.get('endDate'));
    return /*#__PURE__*/_jsxs("span", {
      children: [formattedStart, " - ", formattedEnd]
    });
  }

  // For fiscal periods, apply fiscal offset:
  // - Set year to next year (FY is denoted by year of last month),
  // - Then, subtract offset from month to display correct fiscal quarter or year
  if (timePeriod === 'LAST_FISCAL_QUARTER' || timePeriod === 'LAST_FISCAL_YEAR' || timePeriod === 'NEXT_FISCAL_QUARTER' || timePeriod === 'NEXT_FISCAL_YEAR' || timePeriod === 'THIS_FISCAL_QUARTER' || timePeriod === 'THIS_FISCAL_YEAR') {
    periodDate.setFullYear(periodDate.getFullYear() + 1);
    periodDate.setMonth(periodDate.getMonth() - offset);
  }
  switch (timePeriod) {
    case 'LAST_MONTH':
      return /*#__PURE__*/_jsx(FormattedDateTime, {
        value: periodDate.setMonth(periodDate.getMonth() - 1),
        format: "medium-m-y"
      });
    case 'THIS_MONTH':
      return /*#__PURE__*/_jsx(FormattedDateTime, {
        value: periodDate,
        format: "medium-m-y"
      });
    case 'NEXT_MONTH':
      return /*#__PURE__*/_jsx(FormattedDateTime, {
        value: periodDate.setMonth(periodDate.getMonth() + 1),
        format: "medium-m-y"
      });
    case 'LAST_QUARTER':
      return /*#__PURE__*/_jsx(FormattedShortQuarterYear, {
        value: periodDate.setMonth(periodDate.getMonth() - MONTHS_IN_QUARTER),
        type: "portalTz"
      });
    case 'THIS_QUARTER':
      return /*#__PURE__*/_jsx(FormattedShortQuarterYear, {
        value: periodDate,
        type: "portalTz"
      });
    case 'NEXT_QUARTER':
      return /*#__PURE__*/_jsx(FormattedShortQuarterYear, {
        value: periodDate.setMonth(periodDate.getMonth() + MONTHS_IN_QUARTER),
        type: "portalTz"
      });
    case 'LAST_YEAR':
      return /*#__PURE__*/_jsx("span", {
        children: periodDate.getFullYear() - 1
      });
    case 'THIS_YEAR':
      return /*#__PURE__*/_jsx("span", {
        children: periodDate.getFullYear()
      });
    case 'NEXT_YEAR':
      return /*#__PURE__*/_jsx("span", {
        children: periodDate.getFullYear() + 1
      });
    case 'LAST_FISCAL_QUARTER':
      periodDate.setMonth(periodDate.getMonth() - MONTHS_IN_QUARTER);
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalQuarterPeriodLabel",
        options: {
          quarter: getQuarterFromDate(periodDate),
          year: `${periodDate.getFullYear()}`
        }
      });
    case 'THIS_FISCAL_QUARTER':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalQuarterPeriodLabel",
        options: {
          quarter: getQuarterFromDate(periodDate),
          year: `${periodDate.getFullYear()}`
        }
      });
    case 'NEXT_FISCAL_QUARTER':
      periodDate.setMonth(periodDate.getMonth() + MONTHS_IN_QUARTER);
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalQuarterPeriodLabel",
        options: {
          quarter: getQuarterFromDate(periodDate),
          year: `${periodDate.getFullYear()}`
        }
      });
    case 'LAST_FISCAL_YEAR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalYearPeriodLabel",
        options: {
          year: `${periodDate.getFullYear() - 1}`
        }
      });
    case 'THIS_FISCAL_YEAR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalYearPeriodLabel",
        options: {
          year: `${periodDate.getFullYear()}`
        }
      });
    case 'NEXT_FISCAL_YEAR':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.fiscalYearPeriodLabel",
        options: {
          year: `${periodDate.getFullYear() + 1}`
        }
      });
    default:
      {
        Raven.captureMessage('Unhandled timePeriod value in FormattedPeriod', {
          extra: {
            timePeriod
          }
        });
        return null;
      }
  }
};